/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TagsIndexRouteImport } from './routes/tags/index'
import { Route as SegmentsIndexRouteImport } from './routes/segments/index'
import { Route as GdprIndexRouteImport } from './routes/gdpr/index'
import { Route as CountersIndexRouteImport } from './routes/counters/index'
import { Route as ContactsIndexRouteImport } from './routes/contacts/index'
import { Route as AuditLogsIndexRouteImport } from './routes/audit-logs/index'
import { Route as SettingsTeamRouteImport } from './routes/settings/team'
import { Route as SettingsLinkedinExtensionRouteImport } from './routes/settings/linkedin-extension'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings/integrations'
import { Route as SettingsExternalLinksRouteImport } from './routes/settings/external-links'
import { Route as SettingsCustomFieldsRouteImport } from './routes/settings/custom-fields'
import { Route as SettingsApiTokensRouteImport } from './routes/settings/api-tokens'
import { Route as CountersKeyRouteImport } from './routes/counters/$key'
import { Route as ContactsNewRouteImport } from './routes/contacts/new'
import { Route as ContactsIdRouteImport } from './routes/contacts/$id'
import { Route as SettingsJobsIndexRouteImport } from './routes/settings/jobs/index'
import { Route as AdminTenantsIndexRouteImport } from './routes/admin/tenants/index'
import { Route as AdminJobsIndexRouteImport } from './routes/admin/jobs/index'
import { Route as SettingsJobsKeyRouteImport } from './routes/settings/jobs/$key'
import { Route as AdminJobsSettingsRouteImport } from './routes/admin/jobs/settings'
import { Route as AdminJobsKeyRouteImport } from './routes/admin/jobs/$key'
import { Route as AdminTenantsTenantIdIndexRouteImport } from './routes/admin/tenants/$tenantId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsIndexRoute = TagsIndexRouteImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => rootRouteImport,
} as any)
const SegmentsIndexRoute = SegmentsIndexRouteImport.update({
  id: '/segments/',
  path: '/segments/',
  getParentRoute: () => rootRouteImport,
} as any)
const GdprIndexRoute = GdprIndexRouteImport.update({
  id: '/gdpr/',
  path: '/gdpr/',
  getParentRoute: () => rootRouteImport,
} as any)
const CountersIndexRoute = CountersIndexRouteImport.update({
  id: '/counters/',
  path: '/counters/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsIndexRoute = ContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogsIndexRoute = AuditLogsIndexRouteImport.update({
  id: '/audit-logs/',
  path: '/audit-logs/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: '/settings/team',
  path: '/settings/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLinkedinExtensionRoute =
  SettingsLinkedinExtensionRouteImport.update({
    id: '/settings/linkedin-extension',
    path: '/settings/linkedin-extension',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/settings/integrations',
  path: '/settings/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsExternalLinksRoute = SettingsExternalLinksRouteImport.update({
  id: '/settings/external-links',
  path: '/settings/external-links',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCustomFieldsRoute = SettingsCustomFieldsRouteImport.update({
  id: '/settings/custom-fields',
  path: '/settings/custom-fields',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApiTokensRoute = SettingsApiTokensRouteImport.update({
  id: '/settings/api-tokens',
  path: '/settings/api-tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const CountersKeyRoute = CountersKeyRouteImport.update({
  id: '/counters/$key',
  path: '/counters/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsNewRoute = ContactsNewRouteImport.update({
  id: '/contacts/new',
  path: '/contacts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsIdRoute = ContactsIdRouteImport.update({
  id: '/contacts/$id',
  path: '/contacts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsJobsIndexRoute = SettingsJobsIndexRouteImport.update({
  id: '/settings/jobs/',
  path: '/settings/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsIndexRoute = AdminTenantsIndexRouteImport.update({
  id: '/admin/tenants/',
  path: '/admin/tenants/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminJobsIndexRoute = AdminJobsIndexRouteImport.update({
  id: '/admin/jobs/',
  path: '/admin/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsJobsKeyRoute = SettingsJobsKeyRouteImport.update({
  id: '/settings/jobs/$key',
  path: '/settings/jobs/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminJobsSettingsRoute = AdminJobsSettingsRouteImport.update({
  id: '/admin/jobs/settings',
  path: '/admin/jobs/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminJobsKeyRoute = AdminJobsKeyRouteImport.update({
  id: '/admin/jobs/$key',
  path: '/admin/jobs/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsTenantIdIndexRoute =
  AdminTenantsTenantIdIndexRouteImport.update({
    id: '/admin/tenants/$tenantId/',
    path: '/admin/tenants/$tenantId/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/contacts/new': typeof ContactsNewRoute
  '/counters/$key': typeof CountersKeyRoute
  '/settings/api-tokens': typeof SettingsApiTokensRoute
  '/settings/custom-fields': typeof SettingsCustomFieldsRoute
  '/settings/external-links': typeof SettingsExternalLinksRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/linkedin-extension': typeof SettingsLinkedinExtensionRoute
  '/settings/team': typeof SettingsTeamRoute
  '/audit-logs/': typeof AuditLogsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/counters/': typeof CountersIndexRoute
  '/gdpr/': typeof GdprIndexRoute
  '/segments/': typeof SegmentsIndexRoute
  '/tags/': typeof TagsIndexRoute
  '/admin/jobs/$key': typeof AdminJobsKeyRoute
  '/admin/jobs/settings': typeof AdminJobsSettingsRoute
  '/settings/jobs/$key': typeof SettingsJobsKeyRoute
  '/admin/jobs/': typeof AdminJobsIndexRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/settings/jobs/': typeof SettingsJobsIndexRoute
  '/admin/tenants/$tenantId/': typeof AdminTenantsTenantIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/contacts/new': typeof ContactsNewRoute
  '/counters/$key': typeof CountersKeyRoute
  '/settings/api-tokens': typeof SettingsApiTokensRoute
  '/settings/custom-fields': typeof SettingsCustomFieldsRoute
  '/settings/external-links': typeof SettingsExternalLinksRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/linkedin-extension': typeof SettingsLinkedinExtensionRoute
  '/settings/team': typeof SettingsTeamRoute
  '/audit-logs': typeof AuditLogsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/counters': typeof CountersIndexRoute
  '/gdpr': typeof GdprIndexRoute
  '/segments': typeof SegmentsIndexRoute
  '/tags': typeof TagsIndexRoute
  '/admin/jobs/$key': typeof AdminJobsKeyRoute
  '/admin/jobs/settings': typeof AdminJobsSettingsRoute
  '/settings/jobs/$key': typeof SettingsJobsKeyRoute
  '/admin/jobs': typeof AdminJobsIndexRoute
  '/admin/tenants': typeof AdminTenantsIndexRoute
  '/settings/jobs': typeof SettingsJobsIndexRoute
  '/admin/tenants/$tenantId': typeof AdminTenantsTenantIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/contacts/new': typeof ContactsNewRoute
  '/counters/$key': typeof CountersKeyRoute
  '/settings/api-tokens': typeof SettingsApiTokensRoute
  '/settings/custom-fields': typeof SettingsCustomFieldsRoute
  '/settings/external-links': typeof SettingsExternalLinksRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/linkedin-extension': typeof SettingsLinkedinExtensionRoute
  '/settings/team': typeof SettingsTeamRoute
  '/audit-logs/': typeof AuditLogsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/counters/': typeof CountersIndexRoute
  '/gdpr/': typeof GdprIndexRoute
  '/segments/': typeof SegmentsIndexRoute
  '/tags/': typeof TagsIndexRoute
  '/admin/jobs/$key': typeof AdminJobsKeyRoute
  '/admin/jobs/settings': typeof AdminJobsSettingsRoute
  '/settings/jobs/$key': typeof SettingsJobsKeyRoute
  '/admin/jobs/': typeof AdminJobsIndexRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/settings/jobs/': typeof SettingsJobsIndexRoute
  '/admin/tenants/$tenantId/': typeof AdminTenantsTenantIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contacts/$id'
    | '/contacts/new'
    | '/counters/$key'
    | '/settings/api-tokens'
    | '/settings/custom-fields'
    | '/settings/external-links'
    | '/settings/integrations'
    | '/settings/linkedin-extension'
    | '/settings/team'
    | '/audit-logs/'
    | '/contacts/'
    | '/counters/'
    | '/gdpr/'
    | '/segments/'
    | '/tags/'
    | '/admin/jobs/$key'
    | '/admin/jobs/settings'
    | '/settings/jobs/$key'
    | '/admin/jobs/'
    | '/admin/tenants/'
    | '/settings/jobs/'
    | '/admin/tenants/$tenantId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contacts/$id'
    | '/contacts/new'
    | '/counters/$key'
    | '/settings/api-tokens'
    | '/settings/custom-fields'
    | '/settings/external-links'
    | '/settings/integrations'
    | '/settings/linkedin-extension'
    | '/settings/team'
    | '/audit-logs'
    | '/contacts'
    | '/counters'
    | '/gdpr'
    | '/segments'
    | '/tags'
    | '/admin/jobs/$key'
    | '/admin/jobs/settings'
    | '/settings/jobs/$key'
    | '/admin/jobs'
    | '/admin/tenants'
    | '/settings/jobs'
    | '/admin/tenants/$tenantId'
  id:
    | '__root__'
    | '/'
    | '/contacts/$id'
    | '/contacts/new'
    | '/counters/$key'
    | '/settings/api-tokens'
    | '/settings/custom-fields'
    | '/settings/external-links'
    | '/settings/integrations'
    | '/settings/linkedin-extension'
    | '/settings/team'
    | '/audit-logs/'
    | '/contacts/'
    | '/counters/'
    | '/gdpr/'
    | '/segments/'
    | '/tags/'
    | '/admin/jobs/$key'
    | '/admin/jobs/settings'
    | '/settings/jobs/$key'
    | '/admin/jobs/'
    | '/admin/tenants/'
    | '/settings/jobs/'
    | '/admin/tenants/$tenantId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContactsIdRoute: typeof ContactsIdRoute
  ContactsNewRoute: typeof ContactsNewRoute
  CountersKeyRoute: typeof CountersKeyRoute
  SettingsApiTokensRoute: typeof SettingsApiTokensRoute
  SettingsCustomFieldsRoute: typeof SettingsCustomFieldsRoute
  SettingsExternalLinksRoute: typeof SettingsExternalLinksRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsLinkedinExtensionRoute: typeof SettingsLinkedinExtensionRoute
  SettingsTeamRoute: typeof SettingsTeamRoute
  AuditLogsIndexRoute: typeof AuditLogsIndexRoute
  ContactsIndexRoute: typeof ContactsIndexRoute
  CountersIndexRoute: typeof CountersIndexRoute
  GdprIndexRoute: typeof GdprIndexRoute
  SegmentsIndexRoute: typeof SegmentsIndexRoute
  TagsIndexRoute: typeof TagsIndexRoute
  AdminJobsKeyRoute: typeof AdminJobsKeyRoute
  AdminJobsSettingsRoute: typeof AdminJobsSettingsRoute
  SettingsJobsKeyRoute: typeof SettingsJobsKeyRoute
  AdminJobsIndexRoute: typeof AdminJobsIndexRoute
  AdminTenantsIndexRoute: typeof AdminTenantsIndexRoute
  SettingsJobsIndexRoute: typeof SettingsJobsIndexRoute
  AdminTenantsTenantIdIndexRoute: typeof AdminTenantsTenantIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags/': {
      id: '/tags/'
      path: '/tags'
      fullPath: '/tags/'
      preLoaderRoute: typeof TagsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/segments/': {
      id: '/segments/'
      path: '/segments'
      fullPath: '/segments/'
      preLoaderRoute: typeof SegmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gdpr/': {
      id: '/gdpr/'
      path: '/gdpr'
      fullPath: '/gdpr/'
      preLoaderRoute: typeof GdprIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/counters/': {
      id: '/counters/'
      path: '/counters'
      fullPath: '/counters/'
      preLoaderRoute: typeof CountersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/': {
      id: '/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof ContactsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-logs/': {
      id: '/audit-logs/'
      path: '/audit-logs'
      fullPath: '/audit-logs/'
      preLoaderRoute: typeof AuditLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/team': {
      id: '/settings/team'
      path: '/settings/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof SettingsTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/linkedin-extension': {
      id: '/settings/linkedin-extension'
      path: '/settings/linkedin-extension'
      fullPath: '/settings/linkedin-extension'
      preLoaderRoute: typeof SettingsLinkedinExtensionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/external-links': {
      id: '/settings/external-links'
      path: '/settings/external-links'
      fullPath: '/settings/external-links'
      preLoaderRoute: typeof SettingsExternalLinksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/custom-fields': {
      id: '/settings/custom-fields'
      path: '/settings/custom-fields'
      fullPath: '/settings/custom-fields'
      preLoaderRoute: typeof SettingsCustomFieldsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/api-tokens': {
      id: '/settings/api-tokens'
      path: '/settings/api-tokens'
      fullPath: '/settings/api-tokens'
      preLoaderRoute: typeof SettingsApiTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/counters/$key': {
      id: '/counters/$key'
      path: '/counters/$key'
      fullPath: '/counters/$key'
      preLoaderRoute: typeof CountersKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/new': {
      id: '/contacts/new'
      path: '/contacts/new'
      fullPath: '/contacts/new'
      preLoaderRoute: typeof ContactsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/$id': {
      id: '/contacts/$id'
      path: '/contacts/$id'
      fullPath: '/contacts/$id'
      preLoaderRoute: typeof ContactsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/jobs/': {
      id: '/settings/jobs/'
      path: '/settings/jobs'
      fullPath: '/settings/jobs/'
      preLoaderRoute: typeof SettingsJobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants/': {
      id: '/admin/tenants/'
      path: '/admin/tenants'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AdminTenantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/jobs/': {
      id: '/admin/jobs/'
      path: '/admin/jobs'
      fullPath: '/admin/jobs/'
      preLoaderRoute: typeof AdminJobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/jobs/$key': {
      id: '/settings/jobs/$key'
      path: '/settings/jobs/$key'
      fullPath: '/settings/jobs/$key'
      preLoaderRoute: typeof SettingsJobsKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/jobs/settings': {
      id: '/admin/jobs/settings'
      path: '/admin/jobs/settings'
      fullPath: '/admin/jobs/settings'
      preLoaderRoute: typeof AdminJobsSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/jobs/$key': {
      id: '/admin/jobs/$key'
      path: '/admin/jobs/$key'
      fullPath: '/admin/jobs/$key'
      preLoaderRoute: typeof AdminJobsKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants/$tenantId/': {
      id: '/admin/tenants/$tenantId/'
      path: '/admin/tenants/$tenantId'
      fullPath: '/admin/tenants/$tenantId/'
      preLoaderRoute: typeof AdminTenantsTenantIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContactsIdRoute: ContactsIdRoute,
  ContactsNewRoute: ContactsNewRoute,
  CountersKeyRoute: CountersKeyRoute,
  SettingsApiTokensRoute: SettingsApiTokensRoute,
  SettingsCustomFieldsRoute: SettingsCustomFieldsRoute,
  SettingsExternalLinksRoute: SettingsExternalLinksRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsLinkedinExtensionRoute: SettingsLinkedinExtensionRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  AuditLogsIndexRoute: AuditLogsIndexRoute,
  ContactsIndexRoute: ContactsIndexRoute,
  CountersIndexRoute: CountersIndexRoute,
  GdprIndexRoute: GdprIndexRoute,
  SegmentsIndexRoute: SegmentsIndexRoute,
  TagsIndexRoute: TagsIndexRoute,
  AdminJobsKeyRoute: AdminJobsKeyRoute,
  AdminJobsSettingsRoute: AdminJobsSettingsRoute,
  SettingsJobsKeyRoute: SettingsJobsKeyRoute,
  AdminJobsIndexRoute: AdminJobsIndexRoute,
  AdminTenantsIndexRoute: AdminTenantsIndexRoute,
  SettingsJobsIndexRoute: SettingsJobsIndexRoute,
  AdminTenantsTenantIdIndexRoute: AdminTenantsTenantIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
